export enum AssessmentFilenames {
    assessment = 'assessment.json',
    rubric = 'assessment-result.json',
    submission = 'submission.json'
}